import { frontendURL } from 'dashboard/helper/URLHelper';

const BroadcastsRouteView = () => import('./pages/BroadcastsRouteView.vue');
const BroadcastsListPage = () => import('./pages/BroadcastsListPage.vue');
const BroadcastsFormPage = () => import('./pages/BroadcastsFormPage.vue');
const BroadcastsDetailPage = () => import('./pages/BroadcastsDetailPage.vue');

const meta = {
  permissions: ['administrator'],
};

const broadcastsRoutes = {
  routes: [
    {
      path: frontendURL('accounts/:accountId/broadcasts'),
      component: BroadcastsRouteView,
      children: [
        {
          path: '',
          name: 'broadcasts_index',
          meta,
          component: BroadcastsListPage,
        },
        {
          path: 'new',
          name: 'broadcasts_new',
          meta,
          component: BroadcastsFormPage,
        },
        {
          path: ':broadcastId',
          name: 'broadcasts_show',
          meta,
          component: BroadcastsDetailPage,
        },
        {
          path: ':broadcastId/edit',
          name: 'broadcasts_edit',
          meta,
          component: BroadcastsFormPage,
        },
      ],
    },
  ],
};

export default broadcastsRoutes;
